// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1302f","buttons":"Footer_buttons__svXtL"};